<template>
  <div class="container">
    <div class="nav-tab">
      <div style="display: flex">
        <img src="../../../assets/images/arrow.png" class="ims" alt="" />
        <div>您的当前位置是：首页-政工动态</div>
      </div>
    </div>
    <div class="content">
      <div class="right">
        <div class="right-img">
          <img src="../../../assets/images/inf-news-long.png" alt="" />
          <div class="text">政工动态</div>
        </div>
        <div class="box">
          <div class="news">
            <ul class="custom-list">
              <li v-for="(item, index) in featureList" :key="index">
                <div
                  class="li-content hover-underline wid"
                  @click="goInfo(item)"
                >
                <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.titleContent"
                    placement="top"
                    :open-delay="500"
                  >
                    <div>{{ item.titleContents }}</div>
                  </el-tooltip>
                  <div>[{{ item.releaseTime }}]</div>
                </div>
              </li>
            </ul>
          </div>
          <div class="page-container">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="searchFrom.pageNum"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="searchFrom.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listspecial, dutyList } from "@/api/SpecialWork";
export default {
  name: "ImportantNews",
  props: ["eletype"],
  data() {
    return {
      selectedItem: "消防要闻",
      featureList: [], // 消防要闻
      searchFrom: {
        pageNum: 1,
        pageSize: 20,
        types: 0,
        status: 4,
      },
      guichi: [],
      shitai: [],
      jiuhuashan: [],
      dongzhi: [],
      qingyang: [],
      teqin: [],
      total: 0,
    };
  },
  mounted() {
    this.getlistAll();
  },
  methods: {
    goInfo(item) {
      let url = ``; 
      if (item.fileUrl) {
        url = item.fileUrl;
      }
      window.open(url, "_blank");
    },
    handleSizeChange(val) {
      this.searchFrom.pageSize = val;
      this.getlistAll();
    },
    handleCurrentChange(val) {
      this.searchFrom.pageNum = val;
      this.getlistAll();
    },
    getlistAll() {
      // axios.post('/api/message/release/queryList', this.searchFrom).then(res=>{
      // })
      listspecial(this.searchFrom).then((res) => {
        this.featureList = res.data.data.list;
        this.total = res.data.data.total;
        this.featureList.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
            if (item.titleContent) {
              if (item.titleContent.length > 60) {
                item.titleContents = item.titleContent.slice(0, 60) + "...";
              } else {
                item.titleContents = item.titleContent;
              }
            }
          });
      });
    },
    selectItem(item) {
      this.searchFrom.pageNum = 1;
      this.getlistAll();
    },
    returnshow() {
      this.$emit("setCilck");
    },
  },
};
</script>

<style scoped lang="scss">
.page-container {
  position: absolute;
  bottom: 0px;
}
#map {
  width: 100%;
  height: 398px;
}

.container {
  width: 100%;
  background: #f0f5ff;
}

.nav-tab {
  width: 1120px;
  height: 48px;
  background: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;

  .ims {
    width: 23px;
    height: 20px;
    margin-left: 40px;
    margin-right: 16px;
  }
  .imgs {
    width: 16px;
    margin: 0;
    height: 14px;
    vertical-align: middle;
    margin-right: 8px;
  }
  div {
    font-size: 16px;
    color: #2b56ac;
  }
}
.hover-underline {
  cursor: pointer; /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline; /* 悬停时添加下划线 */
}

.content {
  width: 1120px;
  margin: 0 auto;
  padding-bottom: 40px;
  padding-top: 40px;
  display: flex;
  justify-content: start;
  align-items: flex-start;
  background-color: #fff;

  .custom-list {
    list-style-type: none;
    padding: 0 20px 0 12px;
    width: 1008px;
  }

  .custom-list li {
    position: relative;
    padding-left: 18px;
    margin: 10px 0;
  }

  .custom-list li::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 4px;
    background-color: #c1c5cd;
    border-radius: 50%;
  }

  .li-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;

    span {
      display: inline-block;
      width: 40px;
      height: 18px;
      line-height: 18px;
      text-align: center;
      background: #ffdfdf;
      border-radius: 4px;
      font-size: 10px;
      color: #cc0000;
      // margin-left: 10px;
    }
    .bgc {
      background-color: #f6f6f6;
    }
  }
  .custom-link {
    color: inherit;
    text-decoration: none;
  }
  .left {
    .nav-titie {
      position: relative;
      width: 180px;
      height: 701px;
      background: #0e67ab;
      color: #fff;
      font-weight: bold;
      font-size: 20px;
      padding: 12px;
      box-sizing: border-box;

      .list-box {
        position: absolute;
        top: 53px;
        left: 12px;
        width: 169px;
        background-color: #fff;

        .sidebar {
          width: 168px;
          height: 56px;
          font-size: 14px;
          color: #333333;
          cursor: pointer;
          line-height: 56px;
          padding-left: 20px;
          box-sizing: border-box;
        }

        .sidebar.active {
          background-color: #d4ac62;
          color: #fff;
        }

        img {
          width: 168px;
          height: 100px;
          margin-top: 16px;
        }
      }
    }
  }

  .right {
    width: 1040px;
    background: #ffffff;
    margin-left: 40px;

    .right-img {
      position: relative;

      img {
        width: 1040px;
        height: 30px;
      }

      .text {
        font-weight: bold;
        font-size: 16px;
        color: #ffffff;
        position: absolute;
        top: 5px;
        left: 16px;
      }
    }

    .box {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 820px;
      height: 633px;
      position: relative;
    }
    .news {
      width: 100%;
    }
    .detachment-leader {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      padding: 40px 60px 0 60px;

      img {
        width: 180px;
        height: 180px;
        margin-bottom: 16px;
      }

      .name-detail {
        width: 180px;
        text-align: center;
      }
    }

    .detachment-leader > div:nth-child(2),
    .detachment-leader > div:nth-child(5) {
      margin-left: 90px;
      margin-right: 90px;
    }

    .intro {
      padding-top: 40px;
      background-color: #fff;

      #text {
        display: inline-block;
      }
    }

    .location {
      padding-top: 40px;
    }
  }
}

.bottom-info {
  width: 1120px;
  height: 100px;
  background: #0e67ab;
  color: #fff;
  font-size: 14px;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  .bottom-box div {
    margin: 6px 0;
    text-align: center;
  }
}
.images {
  width: 64px;
  height: 24px;
  margin-top: 22px;
  img {
    width: 64px;
    height: 24px;
  }
}
.hover-underline {
  cursor: pointer; /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline; /* 悬停时添加下划线 */
}
</style>
